export default {
  get: 'GET',
  add: 'ADD',
  remove: 'REMOVE',
  setStatus: 'SET_STATUS',
  address: 'ADDRESS',
};
